export const isOneLowerCaseChar = (input: string) =>
  new RegExp("(?=.*[a-z])").test(input);

export const isOneUpperCaseChar = (input: string) =>
  new RegExp("(?=.*[A-Z])").test(input);

export const isOneNumericChar = (input: string) =>
  new RegExp("(?=.*[0-9])").test(input);

export const isOneSpecialChar = (input: string) =>
  new RegExp("(?=.*[!@#$%^&*.;<>_?])").test(input);

export const isEightCharLong = (input: string) =>
  new RegExp("(?=.{8,})").test(input);

export const isTenCharLong = (input: string) =>
  new RegExp("(?=.{10,})").test(input);

export const isValidEmail = (input: string) =>
  new RegExp("^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+.[a-zA-Z]{2,6}$").test(input);

export const isValidMobile = (input: string) =>
  new RegExp(
    "^(\\+\\d{1,2}\\s)?\\(?\\d{3}\\)?[\\s.-]?\\d{3}[\\s.-]?\\d{3,4}$"
  ).test(input);

export const isValidOib = (input: string) => {
  if (!/^\d{11}$/.test(input)) return false;

  let sum = 10;
  for (let i = 0; i < 10; i++) {
    const digit = parseInt(input[i], 10);
    sum = sum + digit;
    sum = sum % 10;
    if (sum === 0) sum = 10;
    sum = sum * 2;
    sum = sum % 11;
  }

  let controlDigit = 11 - sum;
  if (controlDigit === 10) controlDigit = 0;

  const lastDigit = parseInt(input[10], 10);
  return controlDigit === lastDigit;
}
